import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.attach.title',
    defaultMessage: 'Attach',
    description: 'title of the attach page',
  },
  emptyMessage: {
    id: 'pages.attach.emptyMessage',
    defaultMessage: 'No items available',
    description: 'Empty message of the attach page',
  },
  actions: {
    save: {
      id: 'actions.save',
      defaultMessage: 'Save',
      description: 'Label of the save action on the attach page',
    },
  },
  fields: {
    location: {
      label: {
        id: 'properties.location',
        defaultMessage: 'Location',
        description: 'Label of the location field',
      },
    },
    order: {
      label: {
        id: 'entities.order',
        defaultMessage: 'Order',
        description: 'Label of the order field',
      },
    },
    purchaseOrder: {
      label: {
        id: 'entities.purchase',
        defaultMessage: 'Purchase order',
        description: 'Label of the purchase field',
      },
    },
    inventoryOption: {
      label: {
        id: 'properties.inventoryOption',
        defaultMessage: 'Inventory option',
        description: 'Label of the inventory option field',
      },
    },
  },
  inventoryOptions: {
    available: {
      id: 'inventoryOptions.available',
      defaultMessage: 'Available inventory',
      description: 'Label of the available inventory option',
    },
    backordered: {
      id: 'inventoryOptions.backordered',
      defaultMessage: 'Backordered inventory',
      description: 'Label of the backordered inventory option',
    },
    referenced: {
      id: 'inventoryOptions.referenced',
      defaultMessage: 'Referenced inventory',
      description: 'Label of the referenced inventory option',
    },
  },
  feedback: {
    itemsAttached: {
      id: 'pages.attach.feedback.itemsAttached',
      defaultMessage: 'Items attached',
      description: 'Success message of the attach items action',
    },
    itemsNotAttached: {
      id: 'pages.attach.feedback.itemsNotAttached',
      defaultMessage: 'Items could not be attached',
      description: 'Error message of the attach items action',
    },
  },
};

export default defineMessages(translations);
